import { Component, Input, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { HoverNotification } from '@models/hover-notification';
import { Subscription, fromEvent } from 'rxjs';

@Component({
  selector: 'app-hover-notification',
  templateUrl: './hover-notification.component.html'
})
export class HoverNotificationComponent implements AfterViewInit, OnDestroy {
  @Input() notification: HoverNotification;

  public showRight = true;

  private mouseSubscription: Subscription;

  constructor(private _self: ElementRef) {}

  ngAfterViewInit() {
    this.mouseSubscription = fromEvent(this._self.nativeElement, 'mousemove').subscribe(ev => {
      if (ev) {
        this.showRight = !this.showRight;
      }
    });
  }

  ngOnDestroy() {
    this.mouseSubscription.unsubscribe();
  }
}
